import { createFileRoute } from "@tanstack/react-router";

import { UiShowcasePage } from "@/components/Pages";

export const Route = createFileRoute("/ui")({
  component: UiShowcasePage,
});
